// import React from 'react';

// const CalendarWidget = () => (
//   <div className="bg-white p-4 shadow rounded">
//     <h3 className="text-lg font-semibold mb-3">Calendar</h3>
//     <p className="text-sm text-gray-500">Calendar will show assignments, lessons & events</p>
//     <div className="mt-4 border-t pt-2 text-xs text-gray-400">🟢 Current Day — 📅 Event</div>
//   </div>
// );

// export default CalendarWidget;

// ✅ CalendarWidget.jsx
import React from 'react';

const CalendarWidget = () => {
  return (
    <div className="bg-white shadow-md rounded-xl p-4">
      <h2 className="text-xl font-semibold mb-4">Calendar</h2>
      <div className="text-gray-600">(Calendar integration coming soon...)</div>
    </div>
  );
};

export default CalendarWidget;